import { PrinterSchema } from "@redotech/redo-model/printnode/printer";
import * as z from "zod";

export const getPrintNodeInfo = {
  name: "getPrintNodeInfo" as const,
  input: z.object({ refresh: z.boolean().optional().default(false) }),
  output: z
    .object({
      email: z.string(),
      hasPassword: z.boolean(),
      createdAt: z.date(),
      printers: z.array(PrinterSchema),
    })
    .nullable(),
};
